import React from 'react';
import { ProductTypeForm } from './ProductTypeForm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Tags } from 'lucide-react';
import { ModalBreadcrumbHeader } from '@/components/shared/ModalBreadcrumbHeader';

export interface ProductTypeFormModalProps {
  open?: boolean;
  onClose?: () => void;
  onSuccess?: (newItem: { id: string; label: string; code?: string; original?: any }) => void;
  onCancel?: () => void;
  id?: string;
  mode?: 'create' | 'edit';
  initialData?: any;
  params?: any;
  lockedFields?: Record<string, any>;
  breadcrumb?: string[];
  level?: number;
}

export default function ProductTypeFormModal({
  open,
  onClose,
  onSuccess,
  onCancel,
  id,
  mode,
  initialData,
  params,
  lockedFields,
  breadcrumb,
  level = 0,
}: ProductTypeFormModalProps) {
  const isEdit = !!id || mode === 'edit';

  const handleClose = () => {
    if (onCancel) onCancel();
    if (onClose) onClose();
  };

  const handleSuccess = (newItem: { id: string; label: string; code?: string; original?: any }) => {
    if (onSuccess) {
      onSuccess(newItem);
    }
    if (onClose) onClose();
  };

  const effectiveInitialData = initialData || params;

  const content = (
    <div className="space-y-3">
      <ModalBreadcrumbHeader
        breadcrumbs={breadcrumb}
        title={isEdit ? 'Cập nhật Loại sản phẩm' : 'Thêm mới Loại sản phẩm'}
        icon={Tags}
        iconColor="text-indigo-600"
      />

      <ProductTypeForm
        id={id}
        isModal={true}
        initialData={effectiveInitialData}
        lockedFields={lockedFields}
        onSuccess={handleSuccess}
        onCancel={handleClose}
      />
    </div>
  );

  const zIndexStyle = level > 0 ? { zIndex: 50 + level * 10 } : undefined;

  // When used as standalone modal with explicit open/onClose
  if (open !== undefined && onClose !== undefined) {
    return (
      <Dialog open={open} onOpenChange={(val) => !val && handleClose()}>
        <DialogContent
          style={zIndexStyle}
          className="w-[95vw] sm:max-w-lg md:max-w-xl max-h-[92vh] overflow-y-auto p-5"
        >
          <DialogHeader className="sr-only">
            <DialogTitle>{isEdit ? 'Cập nhật Loại sản phẩm' : 'Thêm mới Loại sản phẩm'}</DialogTitle>
            <DialogDescription>
              {isEdit ? 'Chỉnh sửa thông số loại sản phẩm' : 'Thêm mới phân loại sản phẩm vào danh mục'}
            </DialogDescription>
          </DialogHeader>

          {content}
        </DialogContent>
      </Dialog>
    );
  }

  // When embedded in ComboboxFK which supplies its own Dialog
  return content;
}

export { ProductTypeFormModal };
